<template>
    <b-col cols="12" class="p-3">
        <div v-show="!loading">
            <div v-html="svg_loaded" class="text-center"></div>

            <!-- Legacy b-popover path: kept for teatros without strictRegions
                 (its target elements depend on the SVG markup providing
                 id="popover-{id}"). Strict teatros use native popovers instead. -->
            <template v-if="!loading && load_popover && !strictRegions">
                <b-popover v-for="zona in secciones" :key="zona.id" :target="'popover-' + zona.id" triggers="hover focus" container="body">
                    <template slot="title">{{ zona.name }}</template>
                    <span v-if="!zona.esta_disponible && zona.tiene_precios">{{ $t('partidos.agotadas') }}</span>
                    <span v-else-if="!zona.esta_disponible && !zona.tiene_precios">{{ $t('mapa.no_disponible') }}</span>
                </b-popover>
            </template>
        </div>
        <template v-if="loading">
            <div class="col-12 text-center" style="height: 400px">
                <LoaderComponent/>
            </div>
        </template>
    </b-col>
</template>

<script>
    import { Popover } from 'bootstrap';

    export default {
        props: {
            secciones: {
                type: Array,
                required: true
            }, 
            zona_id: {
                type: Number,
                required: false
            },
            svg: {
                type: String,
                required: true
            },
            /**
             * When true, hover tooltips are attached natively (like
             * ShowSvgSectionComponent) for every region: available sections
             * show their info and unavailable/unknown ones show "No
             * disponible". Opt-in per teatro.
             */
            strictRegions: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                svg_loaded : '',
                loading: true,
                can_click: true,
                load_popover: true,
                popovers: [],
                popoverTargets: []
            }            
        },
        beforeDestroy() {
            this.destroyPopovers();
            var orphans = document.querySelectorAll('.popover');
            for (var o = 0; o < orphans.length; o++) {
                orphans[o].remove();
            }
        },
        created() {
            this.loadSVG(this.svg);

            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if(/windows phone/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/android/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                this.load_popover = false;
            }

        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            }
        },
        methods : {
            destroyPopovers() {
                this.popovers.forEach(function(p) {
                    var tip = p._tip || p.tip;
                    p.hide();
                    p.dispose();
                    if (tip && tip.parentNode) {
                        tip.remove();
                    }
                });
                this.popovers = [];
                this.popoverTargets.forEach(function(target) {
                    var describedBy = target.getAttribute('aria-describedby');
                    if (describedBy) {
                        var el = document.getElementById(describedBy);
                        if (el) el.remove();
                    }
                    target.removeAttribute('aria-describedby');
                    target.style.pointerEvents = 'none';
                });
            },
            loadSVG(svg) {
                this.svg_loaded = svg;

                var vue_instance = this;
                var attempts = 0;

                var tryProcess = function() {
                    if (!vue_instance.secciones || vue_instance.secciones.length === 0) {
                        if (attempts < 30) {
                            attempts++;
                            setTimeout(tryProcess, 200);
                        }
                        return;
                    }

                    var regions = document.getElementsByClassName("recinto-zona");

                    for (var i = 0; i < regions.length; i++) {
                        if (regions[i].dataset !== undefined) {
                            regions[i].classList.add('plaza_ocupada');
                            // Darken unavailable zones
                            var regionChildren = regions[i].querySelectorAll('*');
                            for (var c = 0; c < regionChildren.length; c++) {
                                regionChildren[c].style.fill = '#374151';
                                regionChildren[c].style.opacity = '0.5';
                                regionChildren[c].style.filter = 'blur(1px)';
                            }

                            var matchedZona = null;
                            for (var j = 0; j < vue_instance.secciones.length; j++) {
                                if (vue_instance.secciones[j].id == regions[i].dataset.region) {
                                    matchedZona = vue_instance.secciones[j];
                                    break;
                                }
                            }

                            if (vue_instance.strictRegions && matchedZona === null) {
                                // Unknown section: deny-by-default (already
                                // darkened) with a "No disponible" tooltip.
                                if (vue_instance.load_popover) {
                                    vue_instance.attachNativePopover(regions[i], null);
                                }
                                continue;
                            }

                            if (matchedZona !== null) {
                                if (matchedZona.esta_disponible) {
                                    regions[i].classList.remove('plaza_ocupada');
                                    // Reset fill for available zones
                                    for (var d = 0; d < regionChildren.length; d++) {
                                        regionChildren[d].style.fill = '';
                                        regionChildren[d].style.opacity = '';
                                        regionChildren[d].style.filter = '';
                                    }
                                    regions[i].addEventListener('click', function() {
                                        vue_instance.clickRegion(this.dataset.region);
                                    }, false);
                                }

                                if (vue_instance.strictRegions && vue_instance.load_popover) {
                                    // Every matched section gets a native popover:
                                    // available ones show their name, unavailable
                                    // ones add their status next to it, consistent
                                    // with the zone map (ShowSvgSectionComponent).
                                    // Previously this only ran for unavailable
                                    // sections, which left available ones without
                                    // any tooltip at all.
                                    vue_instance.attachNativePopover(regions[i], matchedZona);
                                }
                            }
                        }
                    }

                    vue_instance.loading = false;
                    vue_instance.$emit('cargado');
                };

                setTimeout(tryProcess, 1000);
            },
            attachNativePopover(region, zona) {
                // Mirror ShowSvgSectionComponent's content shape so both map
                // levels read the same on hover:
                //   available   -> name + "Disponible" (+ libres / desde)
                //   unavailable -> name + "Agotadas" / "No disponible"
                //   unknown     -> "No disponible" only
                var content = '';
                var title = '';
                if (zona === null) {
                    content = 'No disponible';
                } else {
                    title = zona.name || zona.nombre || '';
                    if (zona.esta_disponible) {
                        content = '<div>Disponible</div>';
                        if (zona.libres >= 0) {
                            content += '<div>Libres: ' + zona.libres + '</div>';
                        }
                        if (zona.precios && zona.precios.length > 0) {
                            content += '<div>Desde: ' + zona.precios[0].precio + ' €</div>';
                        }
                    } else {
                        content = zona.tiene_precios ? 'Agotadas' : 'No disponible';
                    }
                }
                var popover = new Popover(region, {
                    title: title,
                    content: content,
                    trigger: 'hover',
                    html: true
                });
                this.popovers.push(popover);
                this.popoverTargets.push(region);
            },
            clickRegion(region_id) {
                // Limpiar popovers huérfanos antes de navegar
                document.querySelectorAll('.popover').forEach(function(el) { el.remove(); });
                let zona = null;
                for (var i = 0; i < this.secciones.length; i++) {
                    if (this.secciones[i].id == region_id) {
                        zona = this.secciones[i];
                    }
                }

                if(zona) {
                    this.$emit('clickZona', zona);
                }            
            }        
        }
    }
</script>